package com.essntl.features.contact.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.delay
import kotlin.collections.orEmpty

enum class ContactDropdownType {
    AGENCY,
    SUPPLIER,
    SUPPLIER_CONTACT
}

@Composable
fun ContactsDropDown(
    state: ContactState,
    onEvent: (ContactEvent) -> Unit,
    type: ContactDropdownType,
    selectedContact: String?,
    onItemSelected: (String) -> Unit,
    starredItem: (String) -> Boolean = { false },
    createNew: Boolean = false,
    enabled: Boolean = true,
    defaultText: String? = null,
    label: String? = null,
    placeholder: String? = null,
    organizationId: String? = null,
    onCreateNew: () -> Unit = {},
    modifier: Modifier = Modifier,
) {
    var searchText by rememberSaveable { mutableStateOf("") }
    var isFocusedHandled by remember { mutableStateOf(false) }

    fun fetchContacts(searchText: String = "") {
        when (type) {
            ContactDropdownType.SUPPLIER_CONTACT -> {
                organizationId?.let { id ->
                    onEvent(
                        ContactEvent.GetOrganizationContacts(
                            organizationId = organizationId,
                            searchText = searchText,
                        ),
                    )
                }
            }

            ContactDropdownType.AGENCY -> {
                onEvent(
                    ContactEvent.GetContacts(
                        type = OrganizationModel.Type.TravelAgency,
                        searchText = searchText,
                    ),
                )
            }

            ContactDropdownType.SUPPLIER -> {
                onEvent(
                    ContactEvent.GetContacts(
                        type = OrganizationModel.Type.Supplier,
                        searchText = searchText,
                    ),
                )
            }
        }
    }

    LaunchedEffect(searchText) {
        if (isFocusedHandled) {
            delay(500)
            fetchContacts(searchText)
        }
    }

    EsInputDropdownMenu(
        modifier = modifier,
        items = state.getAllContacts.data
            ?.map { it.id }
            .orEmpty(),
        selectedItem = selectedContact,
        defaultText = defaultText,
        onFocused = {
            fetchContacts()
            isFocusedHandled = true
        },
        enabled = enabled,
        isFocusedHandled = isFocusedHandled,
        text = { id ->
            val item = state.getAllContacts.data
                ?.firstOrNull { g -> g.id == id }

            item?.name.orEmpty()
        },
        onItemSelected = { id ->
            val itemSelected = state.getAllContacts.data
                ?.firstOrNull { g -> g.id == id }
                ?.id ?: return@EsInputDropdownMenu

            onItemSelected(itemSelected)
        },
        starred = starredItem,
        label = label,
        placeholder = placeholder,
        loading = state.getAllContacts.isLoading,
        message = "",
        topContent = { fm ->
            Spacer(Modifier.height(0.5.spacing))
            Row(
                horizontalArrangement = Arrangement.spacedBy(1.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                EsInput(
                    value = searchText,
                    onValueChange = { searchText = it },
                    placeholder = "Search",
                    prefix = { EsMediumIcon(res = EsIcons.Search) },
                    modifier = Modifier.weight(3f),
                )

                if (createNew)
                    EsLargeSecondaryButton(
                        text = "Create new",
                        suffixIconRes = EsIcons.Add,
                        onClick = {
                            onCreateNew()
                            fm.clearFocus()
                        },
                        modifier = Modifier.weight(1f),
                    )
            }

            Spacer(Modifier.height(1.spacing))
        },
        emptyContent = {
            Text(
                text = "No results found",
                style = MaterialTheme.esTypography.p2Regular14,
            )
        },
    )
}